import $ from 'jquery'
import 'slick-carousel'

import initCarousels from './carousel'
import { initSliders as initSlidersBlog } from '../slider/rangesliderBlog'

initSlidersBlog() // Needs to be loaded asap

$(() => {
    initCarousels() // Carousels
})
